{
  "title": "Customer Master",
  "subtitle": "Parties goods are dispatched to — used by Material Requests, Loading, and Returns.",
  "addCustomer": "Add Customer",
  "search": "Search customers...",
  "edit": "Edit",
  "delete": "Delete",
  "table": {
    "code": "Code",
    "name": "Customer Name",
    "gstin": "GSTIN",
    "contactPerson": "Contact Person",
    "phone": "Phone",
    "status": "Status"
  },
  "tabs": {
    "general": "General",
    "logistics": "Logistics"
  },
  "form": {
    "code": "Customer Code",
    "name": "Customer Name",
    "gstin": "GSTIN",
    "address": "Address",
    "contactPerson": "Contact Person",
    "phone": "Phone",
    "email": "Email",
    "status": "Status",
    "statusActive": "Active",
    "statusInactive": "Inactive",
    "state": "Ship-To State (for GST/E-way)",
    "stateNone": "— Not set —",
    "preferredCarrier": "Preferred Carrier",
    "preferredCarrierNone": "— Not set —",
    "deliveryInstructions": "Delivery Instructions",
    "validation": {
      "codeRequired": "Customer code is required.",
      "nameRequired": "Customer name is required."
    }
  },
  "discardChanges": "Discard Changes",
  "saveCustomer": "Save Customer",
  "deleteCustomer": {
    "message": "This customer will be permanently removed."
  }
}
